module.exports = __webpack_public_path__ + "img/08.4e4e5a61.jpg";